export default () => '404 Page not found';
